
import MessageActions from "../MessageActions";

interface ActionSectionProps {
  isLatestAIMessage: boolean;
  content: string;
  orderNumber: string;
  sellerEmail: string;
}

const ActionSection = ({ 
  isLatestAIMessage, 
  content, 
  orderNumber, 
  sellerEmail 
}: ActionSectionProps) => {
  if (!isLatestAIMessage || !content) return null;
  
  return (
    <MessageActions 
      content={content} 
      orderNumber={orderNumber} 
      sellerEmail={sellerEmail} 
    />
  );
};

export default ActionSection;
